import React, { useContext } from 'react';
import cx from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Checkbox from '@material-ui/core/Checkbox';
import TableCell from '@material-ui/core/TableCell';
import TableContext from '../TableContext';
import { headerHeight } from '../constants';

const useStyles = makeStyles(theme => ({
  flexContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  tableRow: {
    cursor: 'pointer'
  },
  tableRowHover: {
    '&:hover': {
      backgroundColor: theme.palette.grey[200]
    }
  },
  tableCell: {
    flex: 1
  },
  noClick: {
    cursor: 'initial'
  }
}));

const SelectionHeader = ({ tableData }) => {
  const classes = useStyles();
  const { selectable, selected, setSelected, clearSelected } = useContext(
    TableContext
  );
  const rowCount = tableData.length;
  const isSelected = selected.length === rowCount && rowCount > 0;
  const isIndeterminate = selected.length > 0 && selected.length !== rowCount;

  function selectAll() {
    const rowIds = tableData.map(row => row.id);
    setSelected(rowIds);
  }

  function onChange() {
    if (isSelected) {
      clearSelected();
    } else {
      selectAll();
    }
  }

  return (
    <TableCell
      component="div"
      className={cx(classes.tableCell, classes.flexContainer, classes.noClick)}
      variant="head"
      style={{ height: headerHeight }}
      padding="checkbox"
    >
      {selectable && (
        <Checkbox
          indeterminate={isIndeterminate}
          checked={isSelected}
          onChange={onChange}
          inputProps={{ 'data-testid': 'table-head-select-all-checkbox' }}
        />
      )}
    </TableCell>
  );
};

const selectionHeaderRender = ({ columnData }) => {
  return <SelectionHeader tableData={columnData.tableData} />;
};

export default SelectionHeader;
export { selectionHeaderRender };
